import React, { useState, useEffect } from 'react';
import {
  Typography,
  Container,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Avatar,
  TablePagination,
  Snackbar,
  Alert,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import Footer from '../Materials/Footer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import BurgerBar from '../Materials/BurgerBar';

export default function ListSpeedMeetings() {
  const [speedMeetings, setSpeedMeetings] = useState([]);
  const [speedMeetingStates, setSpeedMeetingStates] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [speedMeetingToDelete, setSpeedMeetingToDelete] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [speedMeetingToEdit, setSpeedMeetingToEdit] = useState(null);
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  // Estados para paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showNotification = (message, severity = 'success') => {
    setNotification({
      open: true,
      message,
      severity
    });
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({
      ...prev,
      open: false
    }));
  };

   // Fetch all speed meetings, states e users quando o componente monta
   useEffect(() => {
    fetchSpeedMeetings();
    fetchSpeedMeetingStates();
    fetchUsers(); // Adicionar chamada para buscar utilizadores
  }, []);

  // Adicionar função para buscar utilizadores
  const fetchUsers = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/users');
      if (response.ok) {
        const data = await response.json();
        setUsers(data);
      } else {
        console.error('Failed to fetch users:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Fetch all speed meetings and states when component mounts
  useEffect(() => {
    fetchSpeedMeetings();
    fetchSpeedMeetingStates();
  }, []);

  const fetchSpeedMeetings = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/speedmeetings');
      if (response.ok) {
        const data = await response.json();
        setSpeedMeetings(data);
      } else {
        console.error('Failed to fetch speed meetings:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching speed meetings:', error);
    }
  };

  const fetchSpeedMeetingStates = async () => {
    try {
      const response = await fetch('https://api.hub4food.colab4food.com/api/speedmeeting-states');
      if (response.ok) {
        const data = await response.json();
        setSpeedMeetingStates(data);
      } else {
        console.error('Failed to fetch speed meeting states:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching speed meeting states:', error);
    }
  };

// Function to get icon, color and label based on state name
const getStatusProps = (stateName) => {
  if (!stateName) return { color: 'default', icon: null, label: 'Unknown' };
  
  const lowerCaseState = stateName.toLowerCase();
  
  if (lowerCaseState.includes('To be scheduled')) {
    return { color: 'default', icon: <ScheduleIcon />, label: 'To be scheduled' };
  } else if (lowerCaseState.includes('Scheduled')) {
    return { color: 'warning', icon: <ScheduleIcon />, label: 'Scheduled' };
  } else if (lowerCaseState.includes('Completed')) {
    return { color: 'success', icon: <CheckCircleIcon />, label: 'Completed' };
  } else if (lowerCaseState.includes('Cancelled')) {
    return { color: 'error', icon: <CloseIcon />, label: 'Cancelled' };
  }
  
  return { color: 'default', icon: null, label: stateName };
};

  // Delete meeting functions
  const handleOpenDeleteDialog = (id) => {
    const meeting = speedMeetings.find((meeting) => meeting.id === id);
    setSpeedMeetingToDelete(meeting);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSpeedMeetingToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/speedmeetings/${speedMeetingToDelete.id}`,
        {
          method: 'DELETE',
        }
      );

      if (response.ok) {
        setSpeedMeetings(speedMeetings.filter((meeting) => meeting.id !== speedMeetingToDelete.id));
        setOpenDeleteDialog(false);
        setSpeedMeetingToDelete(null);
        showNotification('Speed meeting deleted successfully!', 'success');
      } else {
        console.error('Failed to delete speed meeting:', response.statusText);
        showNotification('Failed to delete speed meeting.', 'error');
      }
    } catch (error) {
      console.error('Error deleting speed meeting:', error);
      showNotification('An error occurred while deleting the speed meeting.', 'error');
    }
  };

  // Edit meeting functions
  const handleOpenEditDialog = async (id) => {
  try {
    const response = await fetch(`https://api.hub4food.colab4food.com/api/speedmeetings/${id}`);
    if (response.ok) {
      const data = await response.json();
      setSpeedMeetingToEdit({
        ...data,
        date: new Date(data.date).toISOString().slice(0, 16), // Format to "YYYY-MM-DDTHH:MM"
        end_date: data.end_date ? new Date(data.end_date).toISOString().slice(0, 16) : '' // Adicionado
      });
      setOpenEditDialog(true);
    } else {
      console.error('Failed to fetch speed meeting:', response.statusText);
    }
  } catch (error) {
    console.error('Error fetching speed meeting:', error);
  }
};

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setSpeedMeetingToEdit(null);
  };

  const handleSaveEdit = async () => {
    try {
      const response = await fetch(
        `https://api.hub4food.colab4food.com/api/speedmeetings/${speedMeetingToEdit.id}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(speedMeetingToEdit),
        }
      );

      if (response.ok) {
        const savedMeeting = await response.json();
        setSpeedMeetings(speedMeetings.map((meeting) => 
          meeting.id === savedMeeting.id ? savedMeeting : meeting
        ));
        setOpenEditDialog(false);
        setSpeedMeetingToEdit(null);
        showNotification('Speed meeting updated successfully!', 'success');
      } else {
        console.error('Failed to update speed meeting:', response.statusText);
        showNotification('Failed to update speed meeting.', 'error');
      }
    } catch (error) {
      console.error('Error updating speed meeting:', error);
      showNotification('An error occurred while updating the speed meeting.', 'error');
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSpeedMeetingToEdit({ ...speedMeetingToEdit, [name]: value });
  };

  // Funções para paginação
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Speed Meetings da página atual
  const displayedSpeedMeetings = speedMeetings.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Navbar */}
      <BurgerBar />

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        <Paper sx={{ p: 3 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            sx={{ mt: 2, mb: 2 }}
            onClick={() => navigate('/createSpeedMeeting')}
          >
            New Speed Meeting
          </Button>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">User</TableCell>
                  <TableCell align="center">Subject</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Contact</TableCell>
                  <TableCell align="center">State</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
              {displayedSpeedMeetings.map((meeting) => {
                const state = speedMeetingStates.find(state => state.id === meeting.speedmeeting_state_id);
                const user = users.find(user => user.id === meeting.user_id); 
                const statusProps = getStatusProps(state?.state_name);
                  
                  return (
                    <TableRow key={meeting.id} hover>
                      <TableCell align="center">{user?.name || 'N.A'}</TableCell>
                      <TableCell align="center">{meeting.subject}</TableCell>
                      <TableCell align="center">{meeting.description}</TableCell>
                      <TableCell align="center">{meeting.contact}</TableCell>

                      <TableCell align="center">
                        <Chip
                          avatar={<Avatar>{statusProps.icon}</Avatar>}
                          label={statusProps.label}
                          color={statusProps.color}
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>

                      <TableCell align="center">
                        {new Date(meeting.date).toLocaleString('pt-PT', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                          timeZone: 'UTC'
                        })}
                      </TableCell>

                      <TableCell align="center">
                        <Stack direction="row" spacing={1} justifyContent="center">
                          <IconButton 
                            color="primary" 
                            onClick={() => handleOpenEditDialog(meeting.id)}
                            aria-label="edit"
                          >
                            <EditIcon />
                          </IconButton>

                          <IconButton 
                            color="error" 
                            onClick={() => handleOpenDeleteDialog(meeting.id)}
                            aria-label="delete"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Paginação */}
          <TablePagination
            rowsPerPageOptions={[7, 14, 21, 28]}
            component="div"
            count={speedMeetings.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Lines per page:"
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
            }
          />

        </Paper>
      </Container>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Delete Speed Meeting</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete the speed meeting
            <strong> "{speedMeetingToDelete?.subject}"</strong>?
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="inherit">
            Cancel
          </Button>

          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog 
        open={openEditDialog} 
        onClose={handleCloseEditDialog} 
        fullWidth 
        maxWidth="sm"
      >
        <DialogTitle>Edit Speed Meeting</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            label="Subject"
            name="subject"
            value={speedMeetingToEdit?.subject || ''}
            onChange={handleEditChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            fullWidth
            label="Description"
            name="description"
            value={speedMeetingToEdit?.description || ''}
            onChange={handleEditChange}
            margin="normal"
            variant="outlined"
            multiline
            rows={4}
          />

          <FormControl fullWidth margin="normal">
            <InputLabel id="contact-method-label">Contact</InputLabel>
            <Select
              labelId="contact-method-label"
              id="contact-method"
              name="contact"
              value={speedMeetingToEdit?.contact || ''}
              label="Contact"
              onChange={handleEditChange}
              variant="outlined"
            >
              <MenuItem value="Email">Email</MenuItem>
              <MenuItem value="Telephone">Telephone</MenuItem>
              <MenuItem value="Teams">Teams</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel id="speedmeeting-state-label">State</InputLabel>
            <Select
              labelId="speedmeeting-state-label"
              id="speedmeeting-state"
              name="speedmeeting_state_id"
              value={speedMeetingToEdit?.speedmeeting_state_id || ''}
              label="State"
              onChange={handleEditChange}
              variant="outlined"
            >
              {speedMeetingStates.map((state) => (
                <MenuItem key={state.id} value={state.id}>
                  {state.state_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Date and Time"
            name="date"
            type="datetime-local"
            value={speedMeetingToEdit?.date || ''}
            onChange={handleEditChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
          />

          <TextField
            fullWidth
            label="End Date and Time"
            name="end_date"
            type="datetime-local"
            value={speedMeetingToEdit?.end_date || ''}
            onChange={handleEditChange}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="error">
            Cancel
          </Button>

          <Button onClick={handleSaveEdit} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={notification.open}
        autoHideDuration={4000}
        onClose={handleCloseNotification}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      {/* Footer */}
      <Box component="footer" sx={{ py: 3 }}>
        <Footer />
      </Box>
    </Box>
  );
}